










































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import AbpBase from '@/lib/abpbase';
import Util from '@/lib/util';
import elementResizeDetector from "element-resize-detector";
import HzbLetterEdit from '@/views/jm/jobdo/hz/hzbletteredit.vue';
import HzbLetterDetail from '@/views/jm/jobdo/hz/hzbletterdetail.vue';
import ImportBankList from '@/views/jm/jobdo/hz/import-bank-list.vue';
@Component({
components:{HzbLetterEdit,HzbLetterDetail,ImportBankList}
})
export default class HZBLetterViews extends AbpBase {
    @Prop({type:String,default:''}) styname:string;
    loadingInstance:boolean=false;
    editShow:boolean=false;
    detailShow:boolean=false;
    importShow:boolean=false;
    letterid:string="0";
    sendway:number=0;
    WinH=window.innerHeight-110;
    rowStyleOption={
            clickHighlight: false,
            hoverHighlight: true,
    };
    importexcel(){
       this.importShow=true;
    }
    formatStatus (row:any) {
        var num=row.status;
        var way=row.sendWay;
        return Util.format.hzbStatus(num,way);
    }
    create(value:any){
       this.letterid="0";
       this.sendway=value;
       this.editShow=true;
    }
    get itemList(){
        return [{value:'-1',text:'全部'},{value:'0',text:'制函'},{value:'1',text:'待发送'},{value:'2',text:'待回函'},{value:'4',text:'已回函'},{value:'9',text:'已失效'}]
    }
    get list(){
       return this.$store.state.hzbletter.list;
    }
    async itemChange(){
        await this.getdata();
    }
    async refresh(){
        await this.getdata();
    }
    async CellClick(row:any) {  
        var id=row.id;
        if(Number(id)>0){
            this.letterid=id;
            this.sendway=Number(row.sendWay);
            if(Number(row.status)==0)
            {this.editShow=true;}
            else{
                this.detailShow=true;
            }
        }
    }
    async getdata(){
        this.loadingInstance=true;
        let currid=this.$store.state.jobdo.currjob;
        await this.$store.dispatch({
            type:'hzbletter/get',
            data:{ProjectId:currid,Status:this.styname}
        }); 
        this.loadingInstance=false;
    }
    get jobauth(){
       let d= this.$store.state.jobdo.roles;
       if(d.length>0){
          return d[0].checked=='1'?true:false;
       }
       return false;
    }
    async created(){
      await this.getdata();
    }
    mounted(){
        const that = this;
        var erd = elementResizeDetector();
        erd.listenTo(document.getElementsByClassName("el-table"), (element) => {   
        that.$nextTick(() => { 
            that.WinH=window.innerHeight-110;
            });
        });  
    }
}
